/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { KeywordScanCreateUpdateDTOToJSON, KeywordScanExtensionResultDTOToJSON, KeywordScanResponseDTOFromJSON, PaginatedResponseKeywordScanResponseDTOFromJSON, } from '../models/index';
/**
 *
 */
export class KeywordScanControllerApi extends runtime.BaseAPI {
    /**
     */
    async applyExtensionResultRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling applyExtensionResult().');
        }
        if (requestParameters['keywordScanExtensionResultDTO'] == null) {
            throw new runtime.RequiredError('keywordScanExtensionResultDTO', 'Required parameter "keywordScanExtensionResultDTO" was null or undefined when calling applyExtensionResult().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/keyword-scan/{id}/from-extension`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: KeywordScanExtensionResultDTOToJSON(requestParameters['keywordScanExtensionResultDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => KeywordScanResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async applyExtensionResult(requestParameters, initOverrides) {
        const response = await this.applyExtensionResultRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createKeywordScanRaw(requestParameters, initOverrides) {
        if (requestParameters['keywordScanCreateUpdateDTO'] == null) {
            throw new runtime.RequiredError('keywordScanCreateUpdateDTO', 'Required parameter "keywordScanCreateUpdateDTO" was null or undefined when calling createKeywordScan().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/keyword-scan`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: KeywordScanCreateUpdateDTOToJSON(requestParameters['keywordScanCreateUpdateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => KeywordScanResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async createKeywordScan(requestParameters, initOverrides) {
        const response = await this.createKeywordScanRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteKeywordScanRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteKeywordScan().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/keyword-scan/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteKeywordScan(requestParameters, initOverrides) {
        await this.deleteKeywordScanRaw(requestParameters, initOverrides);
    }
    /**
     */
    async deleteKeywordScansRaw(requestParameters, initOverrides) {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError('ids', 'Required parameter "ids" was null or undefined when calling deleteKeywordScans().');
        }
        const queryParameters = {};
        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/keyword-scan/batchDelete`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteKeywordScans(requestParameters, initOverrides) {
        await this.deleteKeywordScansRaw(requestParameters, initOverrides);
    }
    /**
     */
    async getKeywordScanRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getKeywordScan().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/keyword-scan/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => KeywordScanResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async getKeywordScan(requestParameters, initOverrides) {
        const response = await this.getKeywordScanRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getKeywordScansRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }
        if (requestParameters['filterName'] != null) {
            queryParameters['filterName'] = requestParameters['filterName'];
        }
        if (requestParameters['location'] != null) {
            queryParameters['location'] = requestParameters['location'];
        }
        if (requestParameters['locationUrl'] != null) {
            queryParameters['locationUrl'] = requestParameters['locationUrl'];
        }
        if (requestParameters['createdBy'] != null) {
            queryParameters['createdBy'] = requestParameters['createdBy'];
        }
        if (requestParameters['statusList'] != null) {
            queryParameters['statusList'] = requestParameters['statusList'];
        }
        if (requestParameters['createdByNotInList'] != null) {
            queryParameters['createdByNotInList'] = requestParameters['createdByNotInList'];
        }
        if (requestParameters['endDateFrom'] != null) {
            queryParameters['endDateFrom'] = requestParameters['endDateFrom'].toISOString();
        }
        if (requestParameters['endDateTo'] != null) {
            queryParameters['endDateTo'] = requestParameters['endDateTo'].toISOString();
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/keyword-scan`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseKeywordScanResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async getKeywordScans(requestParameters = {}, initOverrides) {
        const response = await this.getKeywordScansRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async markKeywordScanAsExportedRaw(requestParameters, initOverrides) {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError('ids', 'Required parameter "ids" was null or undefined when calling markKeywordScanAsExported().');
        }
        const queryParameters = {};
        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/keyword-scan/markExported`;
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     */
    async markKeywordScanAsExported(requestParameters, initOverrides) {
        const response = await this.markKeywordScanAsExportedRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async partialUpdateKeywordScanRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling partialUpdateKeywordScan().');
        }
        if (requestParameters['keywordScanCreateUpdateDTO'] == null) {
            throw new runtime.RequiredError('keywordScanCreateUpdateDTO', 'Required parameter "keywordScanCreateUpdateDTO" was null or undefined when calling partialUpdateKeywordScan().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/keyword-scan/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: KeywordScanCreateUpdateDTOToJSON(requestParameters['keywordScanCreateUpdateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => KeywordScanResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async partialUpdateKeywordScan(requestParameters, initOverrides) {
        const response = await this.partialUpdateKeywordScanRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async restartKeywordScanRaw(requestParameters, initOverrides) {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError('ids', 'Required parameter "ids" was null or undefined when calling restartKeywordScan().');
        }
        const queryParameters = {};
        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/keyword-scan/restartSearch`;
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     */
    async restartKeywordScan(requestParameters, initOverrides) {
        const response = await this.restartKeywordScanRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const GetKeywordScansStatusEnum = {
    Pending: 'PENDING',
    Inprogress: 'INPROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Suspended: 'SUSPENDED',
    Exported: 'EXPORTED',
    Unavaliable: 'UNAVALIABLE',
    WaitingResults: 'WAITING_RESULTS'
};
/**
 * @export
 */
export const GetKeywordScansLocationEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const GetKeywordScansStatusListEnum = {
    Pending: 'PENDING',
    Inprogress: 'INPROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Suspended: 'SUSPENDED',
    Exported: 'EXPORTED',
    Unavaliable: 'UNAVALIABLE',
    WaitingResults: 'WAITING_RESULTS'
};
